import type { IconSize } from "@octopusdeploy/design-system-icons";
import { CheckIcon, SpinnerIcon, UnavailableIcon, XmarkIcon } from "@octopusdeploy/design-system-icons";
import type { EphemeralEnvironmentProjectStatus } from "@octopusdeploy/octopus-server-client";
import React from "react";
interface EphemeralEnvironmentStatusIconProps {
    status: EphemeralEnvironmentProjectStatus;
    iconSize: IconSize;
}
export function EphemeralEnvironmentStatusIcon({ status, iconSize }: EphemeralEnvironmentStatusIconProps) {
    switch (status) {
        case "NotProvisioned":
            return <UnavailableIcon size={iconSize}/>;
        case "Provisioning":
            return <SpinnerIcon size={iconSize}/>;
        case "ProvisioningFailed":
            return <XmarkIcon size={iconSize}/>;
        case "Provisioned":
            return <CheckIcon size={iconSize}/>;
        case "Deprovisioning":
            return <SpinnerIcon size={iconSize}/>;
        case "DeprovisioningFailed":
            return <XmarkIcon size={iconSize}/>;
        case "Deprovisioned":
            return <UnavailableIcon size={iconSize}/>;
        default:
            return null;
    }
}
